export const getLeaveList = (store) => store.Leave.data;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.Leave;
  return rest;
};
